export class FileObject {
  constructor() {
  }
  public FullPath: string;
  public FileName: string;
  public CreateDate: Date;
  public UpdateDate: Date;
  public Active: boolean;
  public FileData: File;
  public FileType: string;
  public Description: string;
  public EnabledFor: string;
  public Category: number;
  public Type: string;
}
